import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=3daccc43&"
import script from "./ButtonField.vue?vue&type=script&lang=js&"
export * from "./ButtonField.vue?vue&type=script&lang=js&"
import style0 from "./ButtonField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports